import {assert} from 'assert-ts';
import type {ChangeRequest, MetadataEditState} from 'services/metadata/types';

export const assertChangeRequest = (
  taskId: string,
  state: Pick<MetadataEditState, 'metadata'>,
): ChangeRequest => {
  return assert(
    state.metadata?.changeRequests.find(cr => cr.id === taskId),
    `metadataEditReducer.assertChangeRequest: not found`,
    {taskId},
  );
};
